










































































































import Vue from 'vue';
import { Component, Inject, Watch } from 'vue-property-decorator';
import { KFiSelector } from '@kasasa/fbase-components';
import SettingsAndConfigUpgradeReportJobForm from '@/components/settingsAndConfigUpgradeReportForm.vue';
import AkkMappingJobForm from '@/components/akkMappingJobForm.vue';
import AscadAndTunesSeedingForm from '@/components/ascadAndTunesSeedingForm.vue';
import QualRewardsAndLinkedAccountsComparisonJobForm from '@/components/qualRewardsAndLinkedAccountsComparisonForm.vue';
import { UpgradeJobTab, upgradeJobTabs } from '@/types/upgradejobtabs';
import { UpgradeJobInfo } from '@/types/upgradejobinfo';
import { ReportTypeIdUtil, UpgradeReportType } from '@/types/upgradereporttype';
import { UpgradeJobType } from '@/types/upgradejob';
import { Cycle } from '@/types/cycle';
import UpgradeResource from '@/api/upgrade/UpgradeResource';
import ConfigResource from '@/api/config/ConfigResource';

@Component({
  components: {
    'fi-selector': KFiSelector,
    'settings-and-config-upgrade-report-job-form': SettingsAndConfigUpgradeReportJobForm,
    'akk-mapping-job-form': AkkMappingJobForm,
    'ascad-and-tunes-seeding-job-form': AscadAndTunesSeedingForm,
    'qual-rewards-and-linked-accounts-comparison-job-form': QualRewardsAndLinkedAccountsComparisonJobForm,
  },
})
export default class UpgradeJobs extends Vue {
	@Inject('UpgradeResource')
	private upgradeResource!: UpgradeResource;

	@Inject('ConfigResource')
	private configResource!: ConfigResource;

	COMPLETED_STATUS: string = 'COMPLETE';

	FAILED_STATUS: string = 'FAILED';

	DEFAULT_POLLING_INTERVAL_MS: number = 15000; // 15 seconds == 15000 milliseconds

	upgradeJobIdToPollingIdMap: Map<String, number> = new Map();

	loading: boolean = false;

	errorMessage: string = '';

	upgradeJobTabs: Array<UpgradeJobTab> = upgradeJobTabs;

	SETTINGS_AND_CONFIG_UPGRADE_REPORT_BUTTON_ID: string = upgradeJobTabs[0].id;

	AKK_MAPPING_BUTTON_ID: string = upgradeJobTabs[1].id;

	ASCAD_AND_TUNES_SEEDING_BUTTON_ID: string = upgradeJobTabs[2].id;

	QUAL_REWARDS_LINKED_ACCOUNTS_COMPARISON_BUTTON_ID: string =
		upgradeJobTabs[3].id;

	currentlySelectedJobButton: any = null;

	upgradeJobsCurrentlyRunning: Map<UpgradeJobType, Boolean> = new Map();

	upgradeReportHistory: Map<String, Array<Object>> = new Map();

	settingsAndConfigReportHistory: Array<Object> = [];

	anySettingsJobRunning: Boolean = false;

	akkMappingReportHistory: Array<Object> = [];

	noAkkMappingReportHistory: Array<Object> = [];

	anyAkkJobRunning: Boolean = false;

	ascadReportHistory: Array<Object> = [];

	tunesReportHistory: Array<Object> = [];

	tunesDebitsReportHistory: Array<Object> = [];

	anyAscadTunesReportRunning: Boolean = false;

	qualificationsReportHistory: Array<Object> = [];

	rewardsReportHistory: Array<Object> = [];

	linkedAccountsReportHistory: Array<Object> = [];

	anyQualRewardsLinkedReportsRunning: Boolean = false;

	akkMappingFormResetKey: number = 1000;

	ascadTunesFormResetKey: number = 2000;

	qualRewardsLinkedAccountFormResetKey: number = 3000;

	jobDetails: any = {
	  fi: undefined,
	  job: undefined,
	};

	lastThreeCycleData: Array<Cycle> = [];

	submittingJob: boolean = false;

	setUpgradeJobRunning(jobType: UpgradeJobType, isRunning: boolean) {
	  this.upgradeJobsCurrentlyRunning.set(jobType, isRunning);
	  switch (jobType) {
	    case UpgradeJobType.SETTINGS: {
	      this.anySettingsJobRunning = this.upgradeJobsCurrentlyRunning.get(UpgradeJobType.SETTINGS) || false;
	      break;
	    }
	    case UpgradeJobType.AKK: {
	      this.anyAkkJobRunning = this.upgradeJobsCurrentlyRunning.get(UpgradeJobType.AKK) || false;
	      break;
	    }
	    case UpgradeJobType.ASCAD:
	    case UpgradeJobType.TUNES: {
	      this.anyAscadTunesReportRunning =	this.upgradeJobsCurrentlyRunning.get(UpgradeJobType.ASCAD)
					|| this.upgradeJobsCurrentlyRunning.get(UpgradeJobType.TUNES)
					|| false;
	      break;
	    }
	    case UpgradeJobType.QUALIFICATIONS:
	    case UpgradeJobType.REWARDS:
	    case UpgradeJobType.LINKED_ACCOUNTS: {
	      this.anyQualRewardsLinkedReportsRunning =	this.upgradeJobsCurrentlyRunning.get(UpgradeJobType.QUALIFICATIONS)
					|| this.upgradeJobsCurrentlyRunning.get(UpgradeJobType.REWARDS)
					|| this.upgradeJobsCurrentlyRunning.get(UpgradeJobType.LINKED_ACCOUNTS) || false;
	      break;
	    }
	    default: {
	      console.log(`Invalid job type to set to running/stopped:${jobType}`);
	      break;
	    }
	  }
	}

	areAnyJobsRunning() {
	  return (
	    this.anySettingsJobRunning
			|| this.anyAkkJobRunning
			|| this.anyAscadTunesReportRunning
			|| this.anyQualRewardsLinkedReportsRunning
	  );
	}

	showResetErrorMessageButton() {
	  return this.isErrorMessageDisplaying() && !this.areAnyJobsRunning();
	}

	reportHistoryChange() {
	  this.settingsAndConfigReportHistory = this.upgradeReportHistory.get(
	    UpgradeReportType.SETTINGS,
	  )!;
	  this.akkMappingReportHistory = this.upgradeReportHistory.get(
	    UpgradeReportType.AKK,
	  )!;
	  this.noAkkMappingReportHistory = this.upgradeReportHistory.get(
	    UpgradeReportType.NOAKK,
	  )!;
	  this.ascadReportHistory = this.upgradeReportHistory.get(
	    UpgradeReportType.ASCAD,
	  )!;
	  this.tunesReportHistory = this.upgradeReportHistory.get(
	    UpgradeReportType.TUNES,
	  )!;
	  this.tunesDebitsReportHistory = this.upgradeReportHistory.get(
	    UpgradeReportType.TUNES_DEBITS,
	  )!;
	  this.qualificationsReportHistory = this.upgradeReportHistory.get(
	    UpgradeReportType.QUALIFICATIONS,
	  )!;
	  this.rewardsReportHistory = this.upgradeReportHistory.get(
	    UpgradeReportType.REWARDS,
	  )!;
	  this.linkedAccountsReportHistory = this.upgradeReportHistory.get(
	    UpgradeReportType.LINKED_ACCOUNTS,
	  )!;
	}

	clearReportHistory(reportType: string) {
	  this.upgradeReportHistory.set(reportType, []);
	  this.reportHistoryChange();
	}

	@Watch('jobDetails.fi')
	onChangeFi() {
	  if (this.jobDetails.fi !== undefined && this.jobDetails.fi.fiId) {
	    this.loadFiCycleData();
	    this.akkMappingFormResetKey++;
	    this.ascadTunesFormResetKey++;
	    this.qualRewardsLinkedAccountFormResetKey++;
	    if (
	      this.currentlySelectedJobButton !== null
				&& !UpgradeJobs.selectedJobHistoryNeedsCycleSelectedBeforeItCanLoadHistory(
				  this.currentlySelectedJobButton,
				)
	    ) {
	      this.loadPreviousReportsForJobTab(this.currentlySelectedJobButton);
	    }
	  }
	}

	static selectedJobHistoryNeedsCycleSelectedBeforeItCanLoadHistory(
	  jobIndex: number,
	) {
	  return upgradeJobTabs[jobIndex]
	    .requiresSelectedCycleBeforeJobHistoryCanLoad;
	}

	loadFiCycleData() {
	  this.loading = true;

	  this.configResource
	    .loadFiCycleData(this.jobDetails.fi.fiId, '3')
	    .then((result: Cycle[]) => {
	      this.lastThreeCycleData = result;
	      this.loading = false;
	      this.validateCyclesReturned();
	    })
	    .catch((error: any) => {
	      this.resetErrorMessage();
	      this.appendToErrorMessage(
	        'No processing cycles have been configured for this FI.',
	      );
	      this.loading = true;
	    });
	}

	validateCyclesReturned() {
	  if (this.lastThreeCycleData.length === 0) {
	    this.resetErrorMessage();
	    this.appendToErrorMessage(
	      'No processing cycles have been configured for this FI.',
	    );
	  }
	}

	onClickJob(index: number) {
	  if (this.jobDetails.fi) {
	    if (this.isJobIndexSelected(index)) {
	      // if this job is already selected, unselect it
	      this.jobDetails.job = null;
	    } else {
	      this.jobDetails.job = this.upgradeJobTabs[index];
	      if (
	        !UpgradeJobs.selectedJobHistoryNeedsCycleSelectedBeforeItCanLoadHistory(
	          index,
	        )
	      ) {
	        this.loadPreviousReportsForJobTab(index);
	      }
	    }
	  }
	}

	loadPreviousReportsForJobTab(index: number) {
	  this.upgradeJobTabs[index].jobs.forEach((job) => {
	    job.reports.forEach((report) => {
	      this.loadPreviousJobReports(report);
	    });
	  });
	}

	isAJobButtonSelected() {
	  return !(
	    this.currentlySelectedJobButton === undefined
			|| this.currentlySelectedJobButton === null
	  );
	}

	isJobIndexSelected(index: number) {
	  return (
	    this.jobDetails.job !== undefined
			&& this.jobDetails.job !== null
			&& this.jobDetails.job.id === upgradeJobTabs[index].id
	  );
	}

	isJobIdSelected(id: string) {
	  return (
	    this.jobDetails.job !== undefined
			&& this.jobDetails.job !== null
			&& this.jobDetails.job.id === id
	  );
	}

	hasSelectedFi() {
	  return (
	    this.jobDetails.fi !== undefined && this.jobDetails.fi.fiId !== undefined
	  );
	}

	hasLastThreeCyclesData() {
	  return this.lastThreeCycleData.length > 0;
	}

	getSelectedFiId() {
	  return this.jobDetails.fi !== undefined
			&& this.jobDetails.fi.fiId !== undefined
	    ? parseInt(this.jobDetails.fi.fiId, 10)
	    : 0;
	}

	hasSelectedJob() {
	  return (
	    this.jobDetails.job !== undefined && this.jobDetails.fi.fiId !== undefined
	  );
	}

	isErrorMessageDisplaying() {
	  return this.errorMessage.length > 0;
	}

	static getReportFileNameFromKey(s3Key: string) {
	  return s3Key.replace(/^.*[\\/]/, '');
	}

	resetErrorMessage() {
	  this.errorMessage = '';
	  this.currentlySelectedJobButton = null;
	  this.jobDetails.job = undefined;
	}

	appendToErrorMessage(error: string) {
	  if (this.errorMessage.length > 0) {
	    this.errorMessage += `<br>${error}`;
	  } else {
	    this.errorMessage = error;
	  }
	}

	loadPreviousJobReports(
	  reportType: UpgradeReportType,
	  coreProcessingDate?: string,
	) {
	  this.loading = true;

	  this.upgradeResource
	    .loadPreviousJobReports(
	      this.jobDetails.fi.fiId,
	      reportType,
	      coreProcessingDate,
	    )
	    .then((result: any[]) => {
	      this.loading = false;
	      this.upgradeReportHistory.set(reportType, result);
	      this.reportHistoryChange();
	    })
	    .catch((error: any) => {
	      console.log(`error loading reports:${error.message}`);
	      this.loading = false;
	    });
	}

	downloadPreviousReportVersionOfType(
	  reportType: string,
	  reportS3Key: string,
	  versionId: string,
	  coreProcessingDate?: string,
	) {
	  const filename = UpgradeJobs.getReportFileNameFromKey(reportS3Key);

	  this.upgradeResource
	    .downloadPreviousReportVersionOfType(
	      this.jobDetails.fi.fiId,
	      reportType,
	      reportS3Key,
	      versionId,
	      coreProcessingDate,
	    )
	    .then((result: any) => {
	      const responseURL = window.URL.createObjectURL(new Blob([result]));
	      const link = document.createElement('a');
	      link.href = responseURL;
	      link.setAttribute('download', filename);
	      document.body.appendChild(link);
	      link.click();
	    })
	    .catch((error: any) => {
	      console.log(
	        `error downloadPreviousReportVersionOfType: ${error.message}`,
	      );
	      this.appendToErrorMessage('Error downloading report.');
	    });
	}

	runSelectedUpgradeJob(
	  upgradeJobType: UpgradeJobType,
	  runReportUrl: string,
	  runReportRequestBody: any,
	  coreProcessingDate?: string,
	) {
	  this.setUpgradeJobRunning(upgradeJobType, true);
	  this.loading = true;

	  this.upgradeResource
	    .runSelectedUpgradeJob(runReportUrl, runReportRequestBody)
	    .then((response: any) => {
	      this.loading = false;
	      const reportSubmitted = UpgradeJobInfo.fromResponseData(response);
	      const pollingForReportTimoutId = setInterval(
	        () => this.monitorJobStatusUntilCompleted(
	            upgradeJobType,
	            reportSubmitted,
	            coreProcessingDate,
	          ),
	        this.DEFAULT_POLLING_INTERVAL_MS,
	      );
	      this.upgradeJobIdToPollingIdMap.set(
	        reportSubmitted.id,
	        pollingForReportTimoutId,
	      );
	    })
	    .catch((error: any) => {
	      this.setUpgradeJobRunning(upgradeJobType, false);
	      this.loading = false;
	      this.appendToErrorMessage(
	        `Error submitting ${upgradeJobType} upgrade job:${error.message}`,
	      );
	    });
	}

	monitorJobStatusUntilCompleted(
	  jobType: UpgradeJobType,
	  report: UpgradeJobInfo,
	  coreProcessingDate?: string,
	) {
	  this.upgradeResource
	    .monitorJobStatusUntilCompleted(report.id)
	    .then((result: any) => {
	      const jobInfo = UpgradeJobInfo.fromResponseData(result);
	      if (jobInfo.status === this.COMPLETED_STATUS) {
	        clearTimeout(this.upgradeJobIdToPollingIdMap.get(report.id));
	        jobInfo.reports.forEach((returnedReport) => {
	          const reportType = ReportTypeIdUtil.fromS3Key(returnedReport.s3Key);
	          this.setUpgradeJobRunning(jobType, false);
	          this.downloadPreviousReportVersionOfType(
	            reportType,
	            returnedReport.s3Key,
	            returnedReport.version,
	            coreProcessingDate,
	          );
	        });
	      } else if (jobInfo.status === this.FAILED_STATUS) {
	        clearTimeout(this.upgradeJobIdToPollingIdMap.get(report.id));
	        this.setUpgradeJobRunning(jobType, false);
	        this.appendToErrorMessage(
	          `Error running Upgrade Job ${jobType} for FI ${this.getSelectedFiId()}.`
							+ ' Review logs for details.',
	        );
	      }
	    })
	    .catch((error: any) => {
	      console.log(`error:${JSON.stringify(error)}`);
	      this.appendToErrorMessage(error.message);
	    });
	}
}
